import { render, staticRenderFns } from "./Unauthorized.vue?vue&type=template&id=0a1e7ae0"
var script = {}
import style0 from "./Unauthorized.vue?vue&type=style&index=0&id=0a1e7ae0&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports